/**
 * Created by Ning Jiang on 11/24/2016.
 */
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class DirtyWildsSoundConfig implements ISoundConfig {

    public static instance:DirtyWildsSoundConfig = new DirtyWildsSoundConfig();
    public static AS_WIN:string="asWin";
    public static AS_WIN_BIG:string="asWinBig";
    public static COUNT_UP_END:string = "countUpEnds";
    public static COUNT_UP_LOOP:string = "countUpLoop";
    public static COUNT_UP_LOOP_BIWIN:string = "countUpLoopBigwin";
    public static COUNT_UP_MULTIPLIER:string = "countUpMultiplier";

    public static BIG_WIN_START:string = "bigwinStart";
    public static BIG_WIN_MUSIC_LOOP:string = "bigwin";
    public static BIG_WIN_END_1:string = "bigwinEnds1";
    public static BIG_WIN_END_2:string = "bigwinEnds2";
    public static BIG_WIN_END_3:string = "bigwinEnds3";


    static TINY_WIN:string = "winTiny";
    static SMALL_WIN:string = "winSmall";
    static MEDIUM_WIN:string = "winMedium";
    static LARGE_WIN:string = "winLarge";

    MAIN_GAME_AMBIANCE:string = "backgroundMusicMain";
    RESPIN_GAME_AMBIANCE:string = "backgroundMusicRespin";

    REELS_SPIN_START?:string[];
    REELS_SPINNING_START_ON_SPIN_START:string;
    static DIRTYWILDS_REELS_SPINNING:string = "reelsSpinning";
    REELS_SPINNING_STOP_DELAY?:number;

    REELS_DEFAULT_BOUNCE:string[];
    static RANDOM_FEATURE_LOCKED:string = "randomFeatureLocked";
    static RADNOM_TEASE:string = "randomTease";
    static ANTICIPATION_SYNC:string= "anticipationSync";
    static SYNC_LANDING:string = "randomSyncReelsLanding";
    static DIRTYWILDS_REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    static WILD_LAND:string = "wildLand";
    static WILD_LAND_BOUNCE = "wildLandBounce";
    static WILD_EXPLOSION:string = "wildExplosion";
    static WILD_HIGHLIGHT:string = "wildHighlight";
    static WILD_SPIN_BY1:string = "wildSpinBy1";
    static WILD_SPIN_BY2:string = "wildSpinBy2";
    static WILD_SPIN_BY3:string = "wildSpinBy3";
    static WILD_SPIN_BY4:string = "wildSpinBy4";

    static RANDOM_FEATURE_TRIGGERED:string = "randomFeatureTriggered";
    static RANDOM_FEATURE_SLOWDOWN:string = "randomFeatureSlowDown";
    static RANDOM_FEATURE_ATTENTION:string = "randomFeatureAttention";


    static SPIN_COUNTER_UP:string = "spinCounterUp";
    static SPIN_COUNTER_DOWN:string = "spinCounterDown";

    static MULTIPLIER_INDEX_UP:string = "multiplierIndexUp";
    static MULTIPLIER_UP:string = "multiplierUp";

    static ANTICIPATION_TRANSFORM_REEL:string = "anticipationWroom";
    static ANTICIPATION_1:string = "anticipation1";
    static ANTICIPATION_2:string = "anticipation2";
    static ANTICIPATION_3:string = "anticipation3";
    static FEATURE_ENDS:string = "featureEnds";
    static WIN_BETLINE_HIGHLIGHT:string = "winBetlineHighlight";


    constructor() {
        if(DirtyWildsSoundConfig.instance) {
            throw new Error("DirtyWildsSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}